import React from 'react';

import type { ContainerComponent } from '../common/types/Common';
import { GuideEntityProvider } from '../guides/GuideEntityProvider';
import { AdminUserEntityProvider } from './adminUser/AdminUserEntityProvider';
import { MembershipDetailsEntityProvider } from './membership/MembershipDetailsEntityProvider';
import { MembershipEntityProvider } from './membership/MembershipEntityProvider';

export const EntitiesDataProvider: ContainerComponent = ({ children }) => {
    return (
        <AdminUserEntityProvider>
            <GuideEntityProvider>
                <MembershipEntityProvider>
                    <MembershipDetailsEntityProvider>
                        {children}
                    </MembershipDetailsEntityProvider>
                </MembershipEntityProvider>
            </GuideEntityProvider>
        </AdminUserEntityProvider>
    );
};
